module.exports = __webpack_public_path__ + "static/media/SettingsIcon.714f6b9c.png";